import React from "react";
import { Box, Typography } from "@mui/material";

export default function TermsPage() {
  return (
    <Box sx={{ maxWidth: 760, mx: "auto", px: 2, py: 5 }}>
      <Typography variant="h4" fontWeight={600} sx={{ mb: 1 }}>
        TrustBud Terms & Community Standards
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        TrustBud is an accountability relationship product. By using TrustBud, you agree to show up with care,
        respect, and honesty.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        No tolerance for harmful content
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        We do not allow harassment, hate speech, threats, sexual content, scams, or abusive behavior. If you post or send
        harmful content, we may remove it and suspend or ban your account.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Reporting and blocking
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        You can report or block other users at any time. Blocking immediately removes their content from your view.
        Reports are reviewed by TrustBud to help keep the community safe.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Respect and consent
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        TrustBud relationships depend on mutual consent. Do not pressure, shame, or manipulate other users.
      </Typography>

      <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
        Accountability data
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Your activity and messages are used to provide accountability features in the app. Treat shared progress as
        private and respectful.
      </Typography>
    </Box>
  );
}
